import React from 'react'
import { ReactComponent as CheckMark } from '../../assets/icons/check-mark.svg'
import { ReactComponent as XMark } from '../../assets/icons/x-mark.svg'

export const BooleanIcon = ({ condition }: { condition: boolean }) => {
  return condition ? <CheckMark width="18px" fill="green" /> : <XMark width="18px" fill="red" />
}
